<button
  mat-icon-button
  [matTooltip]="'More...'"
  [matTooltipPosition]="'before'"
  [intercomTarget]="'toolbar-more'"
  (click)="moreOptionsMenuTrigger.openMenu()"
>
  <fa-icon [icon]="['fal', 'ellipsis-h']"></fa-icon>
  <div class="menu-trigger" #moreOptionsMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="moreOptionsMenu"></div>
</button>

<mat-menu #moreOptionsMenu="matMenu" [overlapTrigger]="false" [backdropClass]="toolbarBackdropClass">
  <ng-content></ng-content>
</mat-menu>
